import React from 'react';
import UserSmile from "./UserSmile";
import UserStatus from "./UserStatus";

interface PartnerStatusTypingProps {
    typing: boolean;
}

const Typing: React.FC<PartnerStatusTypingProps> = ({typing}) => {
    return (
        <div className={'message-box'}>
            {typing && (
                <div className="typing-indicator">
                    <BouncingDots/>
                </div>
            )}
        </div>
    )
};

const BouncingDots = () => (
    <svg width="30" height="30" viewBox="0 0 70 30" xmlns="http://www.w3.org/2000/svg">
        {/* Двигающаяся точка 1 */}
        <circle cx="15" cy="15" r="5" fill="#a3a3a3">
            <animate
                attributeName="cy"
                values="15;5;15"
                dur="1s"
                repeatCount="indefinite"
            />
        </circle>

        {/* Двигающаяся точка 2 */}
        <circle cx="35" cy="15" r="5" fill="#a3a3a3">
            <animate
                attributeName="cy"
                values="15;5;15"
                dur="1s"
                repeatCount="indefinite"
                begin="0.2s"
            />
        </circle>

        {/* Двигающаяся точка 3 */}
        <circle cx="55" cy="15" r="5" fill="#a3a3a3">
            <animate
                attributeName="cy"
                values="15;5;15"
                dur="1s"
                repeatCount="indefinite"
                begin="0.4s"
            />
        </circle>
    </svg>
);

export default Typing;
